export const s3Upload = async (file) => {
    try {
        // 서버리스 함수에서 Pre-signed URL 발급
        const response = await fetch('/api/upload', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                fileName: file.name,
                contentType: file.type || 'application/octet-stream',
            }),
        });

        if (!response.ok) {
            console.error('Presign failed:', response.statusText);
            return { result: 'fail', savePath: null };
        }

        const { presignedUrl, savePath } = await response.json();

        // Pre-signed URL로 S3에 직접 업로드
        const uploadResponse = await fetch(presignedUrl, {
            method: 'PUT',
            headers: {
                'Content-Type': file.type || 'application/octet-stream',
            },
            body: file,
        });

        if (!uploadResponse.ok) {
            console.error('S3 upload failed:', uploadResponse.statusText);
            return { result: 'fail', savePath: null };
        }

        return { result: 'success', savePath };
    } catch (error) {
        console.error('Upload error:', error);
        return { result: 'fail', savePath: null };
    }
};
